import { all, call, put, takeEvery } from "redux-saga/effects";
import { LOGIN_USER, REGISTER_USER, LOGIN_USER_SUCCESS, REGISTER_USER_SUCCESS, LOGIN_AD_USER, LOGIN_AD_USER_SUCCESS, SHOW__HIDE_LOADER, LOGOUT, LOGOUT_SUCCESS, UNMOUNT_REGISTER, UNMOUNT_REGISTER_USER_SUCCESS, UNMOUNT_PREVIEW_RESPONSE_SUCCESS, UNMOUNT_USER_ASSIGNED_COUNTRY_LIST_SUCCESS, UNMOUNT_DASHBOARD_DATA_SUCCESS, VERIFY_CAPTCHA, VERIFY_CAPTCHA_SUCCESS, GET_APP_SETTINGS, GET_APP_SETTINGS_SUCCESS } from '../constants/constants';
import { loginUserCall, registerUserCall, loginUserAdCall, verifyCaptchaCall, getAppSettingsCall } from '../effects/api/api.userAuth';
import { setLocalStorageValue/* , getLocalStorageValue */ } from '../effects/utils/local-storage';

function* registerUser(data: any) {
  try {

    yield put({ type: SHOW__HIDE_LOADER, payload: true });

    const response = yield call(registerUserCall, data);
    yield put({ payload: response, type: REGISTER_USER_SUCCESS });

    yield put({ type: SHOW__HIDE_LOADER, payload: false });

  } catch (err) {
    yield put({ type: SHOW__HIDE_LOADER, payload: false });
  }
}

function* loginUser(data: any) {

  try {

    yield put({ type: SHOW__HIDE_LOADER, payload: true });

    const response = yield call(loginUserCall, data.payload);
    if (response && response.status === 200) {
      setLocalStorageValue('user', JSON.stringify(response.data.payload));
    }

    yield put({ payload: response, type: LOGIN_USER_SUCCESS });
    yield put({ type: SHOW__HIDE_LOADER, payload: false });

  } catch (err) {
    yield put({ type: SHOW__HIDE_LOADER, payload: false });
  }
}

function* verifyCaptcha(data: any) {

  try {

    yield put({ type: SHOW__HIDE_LOADER, payload: true });
    const response = yield call(verifyCaptchaCall, data.payload);

    yield put({ payload: response, type: VERIFY_CAPTCHA_SUCCESS });
    yield put({ type: SHOW__HIDE_LOADER, payload: false });

  } catch (err) {
    yield put({ type: SHOW__HIDE_LOADER, payload: false });
  }
}

function* getAppSettings() {

  try {

    yield put({ type: SHOW__HIDE_LOADER, payload: true });
    const response = yield call(getAppSettingsCall);

    yield put({ payload: response, type: GET_APP_SETTINGS_SUCCESS });
    yield put({ type: SHOW__HIDE_LOADER, payload: false });

  } catch (err) {
    yield put({ type: SHOW__HIDE_LOADER, payload: false });
  }
}

function* loginAdUser(data: any) {

  try {

    yield put({ type: SHOW__HIDE_LOADER, payload: true });

    const response = yield call(loginUserAdCall, data.payload);
    if (response && response.status === 200) {
      setLocalStorageValue('user', JSON.stringify(response.data.payload));
    }

    yield put({ payload: response, type: LOGIN_AD_USER_SUCCESS });

    yield put({ type: SHOW__HIDE_LOADER, payload: false });

  } catch (err) {
    yield put({ type: SHOW__HIDE_LOADER, payload: false });
  }
}

function* logout() {
  try {
    yield put({ type: SHOW__HIDE_LOADER, payload: true });
    yield put({ type: LOGOUT_SUCCESS, payload: false });
    yield put({ payload: null, type: UNMOUNT_PREVIEW_RESPONSE_SUCCESS });
    yield put({ payload: null, type: UNMOUNT_USER_ASSIGNED_COUNTRY_LIST_SUCCESS });
    yield put({ payload: null, type: UNMOUNT_DASHBOARD_DATA_SUCCESS });
    yield put({ type: SHOW__HIDE_LOADER, payload: false });

  } catch (err) {
    yield put({ type: SHOW__HIDE_LOADER, payload: false });
  }
}

function* unmountRegisterState() {
  try {
    yield put({ type: SHOW__HIDE_LOADER, payload: true });

    yield put({ type: UNMOUNT_REGISTER_USER_SUCCESS, payload: null });

    yield put({ type: SHOW__HIDE_LOADER, payload: false });

  } catch (err) {
    yield put({ type: SHOW__HIDE_LOADER, payload: false });
  }
}

export default function* UserAuthSaga() {
  yield all([
    takeEvery(REGISTER_USER, registerUser),
    takeEvery(LOGIN_USER, loginUser),
    takeEvery(LOGIN_AD_USER, loginAdUser),
    takeEvery(UNMOUNT_REGISTER, unmountRegisterState),
    takeEvery(LOGOUT, logout),
    takeEvery(VERIFY_CAPTCHA, verifyCaptcha),
    takeEvery(GET_APP_SETTINGS, getAppSettings),
  ])
}



// WEBPACK FOOTER //
// ./src/saga/saga.userAuth.tsx